var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "affiliateProgram",
      staticClass: "right-body",
      attrs: {
        id: "affiliateProgram",
        "element-loading-background": "rgba(0, 0, 0, 0.05)"
      }
    },
    [
      _c("div", { staticClass: "ap-model" }, [
        _c("div", { staticClass: "ap-body", class: _vm.getH2Height() }, [
          _c("div", { staticClass: "ap-title" }, [
            _c("div", { staticClass: "ap-title-text" }, [
              _c("h1", [
                _c("div", { staticClass: "icon ap_orange_title" }),
                _vm._v(
                  "\n              " +
                    _vm._s(_vm.$t("language.affiliateProgram.title")) +
                    "\n            "
                )
              ])
            ]),
            _vm._v(" "),
            _c("p", {
              domProps: {
                innerHTML: _vm._s(_vm.$t("language.affiliateProgram.headTips1"))
              }
            }),
            _vm._v(" "),
            _c("p", {
              domProps: {
                innerHTML: _vm._s(_vm.$t("language.affiliateProgram.headTips2"))
              }
            }),
            _vm._v(" "),
            _c("p", {
              domProps: {
                innerHTML: _vm._s(_vm.$t("language.affiliateProgram.headTips3"))
              }
            }),
            _vm._v(" "),
            _c("div", [
              _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      return _vm.openSignUp()
                    }
                  }
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("language.affiliateProgram.signUpBtn"))
                    )
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("p", {
              domProps: {
                innerHTML: _vm._s(_vm.$t("language.affiliateProgram.tips"))
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ap-line" }),
          _vm._v(" "),
          _c("div", { staticClass: "ap-center" }, [
            _c("h2", [
              _vm._v(_vm._s(_vm.$t("language.affiliateProgram.howDoTipsTitle")))
            ]),
            _vm._v(" "),
            _c("p", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("language.affiliateProgram.howDoTipsMsg")
                )
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ap-line" }),
          _vm._v(" "),
          _c("div", { staticClass: "ap-FAQ" }, [
            _c("h2", [
              _vm._v(_vm._s(_vm.$t("language.affiliateProgram.FAQsTitle")))
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "ap-FAQ-els", style: _vm.getFAQHeight() },
              [
                _c(
                  "el-scrollbar",
                  { ref: "scroll", staticStyle: { height: "100%" } },
                  [
                    _c("div", { staticStyle: { padding: "0px 12px 0 0" } }, [
                      _c("div", { staticClass: "ap-FAQ-body" }, [
                        _c(
                          "div",
                          {
                            staticClass: "ap-FAQ-q",
                            on: {
                              click: function($event) {
                                return _vm.chickFAQBtn(1)
                              }
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("language.affiliateProgram.FAQ1"))
                              )
                            ]),
                            _vm._v(" "),
                            _vm.faqStatus != 1
                              ? _c("div", { staticClass: "icon ap_faq_down" })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.faqStatus == 1
                              ? _c("div", { staticClass: "icon ap_faq_up" })
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _vm.faqStatus == 1
                          ? _c("p", { staticClass: "ap-FAQ-a" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("language.affiliateProgram.answer1")
                                )
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "ap-FAQ-body" }, [
                        _c(
                          "div",
                          {
                            staticClass: "ap-FAQ-q",
                            on: {
                              click: function($event) {
                                return _vm.chickFAQBtn(2)
                              }
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("language.affiliateProgram.FAQ2"))
                              )
                            ]),
                            _vm._v(" "),
                            _vm.faqStatus != 2
                              ? _c("div", { staticClass: "icon ap_faq_down" })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.faqStatus == 2
                              ? _c("div", { staticClass: "icon ap_faq_up" })
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _vm.faqStatus == 2
                          ? _c("p", { staticClass: "ap-FAQ-a" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("language.affiliateProgram.answer2")
                                )
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.faqStatus == 2
                          ? _c("p", { staticClass: "ap-FAQ-ps" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("language.affiliateProgram.answerPs2")
                                )
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "ap-FAQ-body" }, [
                        _c(
                          "div",
                          {
                            staticClass: "ap-FAQ-q",
                            on: {
                              click: function($event) {
                                return _vm.chickFAQBtn(3)
                              }
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("language.affiliateProgram.FAQ3"))
                              )
                            ]),
                            _vm._v(" "),
                            _vm.faqStatus != 3
                              ? _c("div", { staticClass: "icon ap_faq_down" })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.faqStatus == 3
                              ? _c("div", { staticClass: "icon ap_faq_up" })
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _vm.faqStatus == 3
                          ? _c("p", { staticClass: "ap-FAQ-a" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("language.affiliateProgram.answer3")
                                )
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "ap-FAQ-body ap-FAQ-last" }, [
                        _c(
                          "div",
                          {
                            staticClass: "ap-FAQ-q",
                            on: {
                              click: function($event) {
                                return _vm.chickFAQBtn(4)
                              }
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("language.affiliateProgram.FAQ4"))
                              )
                            ]),
                            _vm._v(" "),
                            _vm.faqStatus != 4
                              ? _c("div", { staticClass: "icon ap_faq_down" })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.faqStatus == 4
                              ? _c("div", { staticClass: "icon ap_faq_up" })
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _vm.faqStatus == 4
                          ? _c("p", { staticClass: "ap-FAQ-a" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("language.affiliateProgram.answer4")
                                )
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.faqStatus == 4
                          ? _c("p", { staticClass: "ap-FAQ-ps" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("language.affiliateProgram.answerPs4")
                                )
                              )
                            ])
                          : _vm._e()
                      ])
                    ])
                  ]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ap-center" }, [
            _c("h2", [
              _vm._v(
                _vm._s(_vm.$t("language.affiliateProgram.anyQuestionTitle"))
              )
            ]),
            _vm._v(" "),
            _c("p", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("language.affiliateProgram.anyQuestionTip")
                )
              }
            })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "task-buttom" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29daa041", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29daa041","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/affiliateProgram.vue
// module id = null
// module chunks = 